const OurStory = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      tag: "OUR STORY",
      title: "Where It All Began",
      p1:
        "In 1996, Jeffeury Tan founded what would become one of Singapore’s most respected financial advisory agencies. What started as a modest team driven by conviction grew steadily into a culture of excellence.",
      p2:
        "Today, the JT Group — encompassing SP-JTGroup and SP-GABY Group, co-led by Jeffeury Tan and Juanna-Gaby Fung — stands as a combined force of talent, experience, and innovation. Our journey is more than growth in numbers. It is a story of lives changed, families protected, and futures secured — together.",
    },

    zh: {
      tag: "我们的故事",
      title: "故事的开始",
      p1:
        "1996 年，Jeffeury Tan 创立了这家后来成为新加坡最受尊敬的金融咨询机构之一的公司。从一个充满信念的小团队开始，逐步发展成为追求卓越的企业文化。",
      p2:
        "如今，JT Group（包括 SP-JTGroup 和 SP-GABY Group），由 Jeffeury Tan 与 Juanna-Gaby Fung 共同领导，汇聚了人才、经验与创新。我们的成长不仅是数字的增长，更是守护家庭、改变人生、创造未来的旅程。",
    },
  };

  return (
    <section className="bg-white py-10">
      <div className="max-w-[900px] mx-auto px-6 text-center">

        {/* Label */}
        <p className="text-[#C09F7C] font-semibold tracking-wide mb-4">
          {text[lang].tag}
        </p>

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-medium text-[#154059] mb-6">
          {text[lang].title}
        </h2>

        {/* Paragraph 1 */}
        <p className="text-gray-600 leading-relaxed mb-6">
          {text[lang].p1}
        </p>

        {/* Paragraph 2 */}
        <p className="text-gray-600 leading-relaxed">
          {text[lang].p2}
        </p>

      </div>
    </section>
  );
};

export default OurStory;